export const SECONDARY_NAV_CONTEXT = "secondaryNav"
export const USER_MENU_CONTEXT = "userMenu"
export const WALLET_MENU_CONTEXT = "walletMenuContext"
export const NOTIFICATION_CENTER_CONTEXT = "notificationCenter"
